export default class {
	constructor(options) {
		this.defaults = {
			$el: null,
		};
		this.options = {};
		this.allowFetch = true;
		Object.assign(this.options, this.defaults, options);

		this.namespace = "chipsFetch";
		if (this.options.$el) {
			this.$el = this.options.$el;
		}
		this.init(true);
	}

	init(bool) {
		if (bool) {
			this.initChipsFetch();

			window.onpopstate = function (event) {
				// window.location = document.location;
				Turbo.visit(document.location);
			};
		} else {
		}
	}

	initChipsFetch() {
		const scopeThis = this;
		const $el = document.querySelectorAll(".fetch-button");
		if ($el && $el.length) {
			$el.forEach((el) => {
				el.addEventListener("click", (e) => {
					e.preventDefault();

					const url = el.getAttribute("data-href");
					const container = document.querySelector(".loop-wrap");

					this.doFetch(url, container);
				});
			});
		}

		// const $modalLinks = document.querySelectorAll(".modal-contents a");
		// if ($modalLinks && $modalLinks.length) {
		// 	$modalLinks.forEach((el) => {
		// 		// if el has class .no-ajax, do nothing

		// 		el.addEventListener("click", (e) => {
		// 			e.preventDefault();

		// 			const url = el.getAttribute("href");
		// 			const container = document.querySelector(".loop-wrap");

		// 			this.doFetch(url, container, ".modal-contents");
		// 		});
		// 	});
		// }
	}

	doFetch(url, loopWrap, additional = false) {
		const scopeThis = this;
		if (this.allowFetch) {
			this.allowFetch = false;

			if (loopWrap) {
				const fetchWrap = document.createElement("div");
				fetchWrap.setAttribute("id", "fetch-wrap");
				loopWrap.parentNode.insertBefore(fetchWrap, loopWrap);
				fetchWrap.appendChild(loopWrap);
				const children = fetchWrap.children;
				for (let i = 0; i < children.length; i++) {
					children[i].classList.add("chips-leaving");
				}
			}

			fetch(url)
				.then((response) => response.text())
				.then((html) => {
					const parser = new DOMParser();
					const doc = parser.parseFromString(html, "text/html");
					const newContainer = doc.querySelector(".loop-wrap");

					const fetchWrap = document.querySelector("#fetch-wrap");
					fetchWrap.parentNode.insertBefore(
						newContainer,
						fetchWrap.nextSibling
					);

					if (additional) {
						if (additional.indexOf(",") > -1) {
						} else {
							additional = additional + ",";
						}
						const addItems = additional.split(",");
						addItems.forEach((item) => {
							if (item !== "") {
								const newAddContainer = doc.querySelector(item);
								const addContainer =
									document.querySelector(item);
								addContainer.innerHTML =
									newAddContainer.innerHTML;
							}
						});
					}

					window.history.pushState({ path: url }, "", url);

					setTimeout(function () {
						fetchWrap.remove();
						scopeThis.allowFetch = true;
						scopeThis.initChipsFetch();
					}, 800);
				})
				.catch((error) => {
					console.warn(error);
				});
		}
	}
}
